import { render, staticRenderFns } from "./PCurrencySelect.vue?vue&type=template&id=7384c319"
import script from "./PCurrencySelect.vue?vue&type=script&lang=js"
export * from "./PCurrencySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports